module.exports = __webpack_public_path__ + "img/08.9d44be44.png";